import { render, staticRenderFns } from "./BatchTextQrModal.vue?vue&type=template&id=2d12000f&scoped=true"
import script from "./BatchTextQrModal.vue?vue&type=script&lang=js"
export * from "./BatchTextQrModal.vue?vue&type=script&lang=js"
import style0 from "./BatchTextQrModal.vue?vue&type=style&index=0&id=2d12000f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d12000f",
  null
  
)

export default component.exports